import { PropsWithChildren } from 'react';
import { DayCell } from '@lp/features/Scheduler/components';
import { SOrganGroup } from '@lp/features/Scheduler/SchedulerSurgeons/types';
import { SchedulerDayColumn } from '@lp/features/Scheduler/types';
import { ReservationNode } from '@/api/apis/resources';
import { ReservationBar } from './components';
import { CaseResourceType } from '@/api/apis/case';

type CSAssignmentCellProps = PropsWithChildren<{
  isRestReadOnly: boolean;
  column: SchedulerDayColumn;
  resourceType: CaseResourceType;
  organGroup?: SOrganGroup;
  reservations?: ReservationNode[];
}>;

export const ReservationCell = ({
  column,
  reservations,
  resourceType,
  organGroup,
  isRestReadOnly,
  children,
}: CSAssignmentCellProps) => {
  return (
    <DayCell active={column.isSelectedDay}>
      <div className="flex flex-col gap-1 h-full -mx-1">
        <div className="flex min-h-2.5">{children}</div>
        <div className="h-full grow">
          <ul className="flex flex-col gap-0.5 list-disc list-outside ms-2">
            {reservations?.map((item) => (
              <li key={item.nodeId} className="text-xs-m">
                <ReservationBar
                  data={item}
                  isRestReadOnly={isRestReadOnly}
                  resourceType={resourceType}
                  organGroup={organGroup}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </DayCell>
  );
};
